import React, { useEffect, useState } from 'react'
import ScheduleLayout from '../layout/ScheduleLayout'
import holidaysServices from '../holidaysServices';
import BusinessHolidayForm from '../components/BusinessHolidayForm';
import moment from 'moment/moment';
import ConfirmDialog from '../../../../components/ConfirmDialog';
import { Warning } from '@mui/icons-material';
import { useAlert } from '../../../../context/AlertContext';

function BusinessHolidayPage() {

    const {AppAlert} = useAlert()
    const [holidayList,setHolidayList] = useState(null);

    const getHolidayList = () =>{
        holidaysServices.getList().then(res=>{
            setHolidayList(res.data);
        }).catch(error=>{
        }).finally()
    }
    useEffect(()=>{
        getHolidayList();
    },[])

    const remove = (id) =>{
        holidaysServices.remove(id).then(res=>{
            AppAlert("Holiday Removed !")
            getHolidayList();
        }).catch(error=>{

        })
    }

    return (
        <ScheduleLayout>
            <div className='row'>
                <div className='col-md-6'>
                    <h3>Holiday  Calendar</h3>
                </div>
                <div className='col-md-6'>
                    <span className='float-end'><BusinessHolidayForm callBack={getHolidayList} /> </span>
                </div>
                <div className='col-md-12'>
                    <table className='table table-striped'>
                        <thead>
                            <tr>
                                <td>Date</td>
                                <td>Occasion</td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            {holidayList && holidayList.map(holiday=>
                                <tr key={holiday.id}>
                                    <td>{moment(holiday.holidayDate).format("dddd, LL")}</td>
                                    <td className='fw-bold'>{holiday.occasion}</td>
                                    <td>
                                        <BusinessHolidayForm data={holiday} callBack={getHolidayList}/>
                                        <ConfirmDialog id={holiday.id} confirm={remove}>
                                            <div className='alert alert-danger'>
                                                <h4> <Warning/> Are you Sure You want to Remove</h4>
                                            </div>
                                        </ConfirmDialog>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            
        </ScheduleLayout>
    )
}

export default BusinessHolidayPage